import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_IMPACT_STORIES = defineFcm('impact_stories')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			keys: getLocales(),
			optional: true,
			optionalValues: true,
			shape: {
				type: 'object',
				optional: true,
				shape: {
					impactStories: {
						type: 'record',
						optional: true,
						shape: {
							type: 'object',
							shape: {
								summary: { type: 'string' },
								bubbleImageUrl: { type: 'string' },
								title: { type: 'string' },
								videoUrl: { type: 'string', optional: true },
								imageUrl: { type: 'string', optional: true },
								paragraphs: {
									type: 'array',
									shape: { type: 'string' },
								},
								quoteImage: { type: 'string' },
								starterQuote: { type: 'string' },
								sapImage: { type: 'string' },
								badgeLabel: { type: 'string' },
							},
						},
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		return {
			...globalValue,
			...localeValue,
			...countryValue,
		};
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		context:
			'Per-locale impact story content: each locale key maps to impactStories keyed by petition slug or ID. Stories intended to be accessible to all users (e.g. en-US content shown as a fallback) must be placed in the Global bucket — locale and country buckets are only for overriding specific locale keys for users in those regions.',
		description:
			'Single source of truth for impact story content. The homepage reads locale-aware top stories from this config, and /impact-stories/:slugOrId resolves story content across locale buckets so stories remain accessible even when URLs are shared across regions.',
		mergeLogic:
			'Locale keys are merged across all three buckets (country overrides locale overrides global for the same key). We first lookup the users locale within the Country config and then the Locale config. So for example, a user with country_code=CA and lang=es-ES, we would lookup the es-ES locale within the CA country config, then the es-ES locale config.',
		template: {
			'en-US': {
				impactStories: {
					'petition-slug': {
						summary: 'Summary shown below bubble',
						bubbleImageUrl: 'URL',
						title: '',
						videoUrl: 'Optional URL',
						imageUrl: 'Optional URL',
						paragraphs: ['', ''],
						quoteImage: 'URL',
						starterQuote: 'Quote',
						sapImage: 'URL',
						badgeLabel: 'Label',
					},
				},
			},
		},
	});
